import type { PathTurnSteps_Step } from "./PathTurnSteps_Step.type"

export default function canEndMoveOnStep(step: PathTurnSteps_Step) {
  return (
    !step.impass && !step.occupant && !step.enemies.length
  ) as boolean
}
